import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { IZoomEvent } from '../../../_models/models';
import { GoldenLayoutContainerInjectionToken, WidgetHostDirective } from '../../../_directives/widget-host.directive';
import { ComponentContainer } from 'golden-layout';
import { DashboardService } from '../../dashboard/dashboard.service';
import { EsService } from '../../../_services/http/es.service';
import { EvenementSpontane, IEvenementSpontane } from '../../../_models/EvenementSpontane';
import { Alarme } from '../../../_models/Alarme';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../../_store/mainStoreState';
import { loadEvenementSpontanesAction, selectAllEvenementSpontanes } from '../../../_store/EvenementSpontaneStore/evenement-spontane.store';
import { ConfigService } from '../../../_services/local/config.service';
import { GridWrapper } from '../../../_models/GridWrapper';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, distinct, filterBy } from '@progress/kendo-data-query';

@Component({
  selector: 'app-es-list',
  templateUrl: './es-list.component.html',
  styleUrls: ['./es-list.component.scss'],
})
export class EsListComponent extends WidgetHostDirective implements OnInit, OnDestroy {
  @ViewChild('kendoGrid', { static: true }) kendoGrid!: GridComponent;

  public types = this.configService.Config.esTypes;

  // Grid attributes
  public gridWrapper!: GridWrapper<EvenementSpontane>;

  private channel = new BroadcastChannel('map-vec');
  private channelAvancementList = new BroadcastChannel('avancement-list');

  constructor(
    @Inject(GoldenLayoutContainerInjectionToken) container: ComponentContainer,
    elRef: ElementRef,
    renderer: Renderer2,
    viewContainerRef: ViewContainerRef,
    store: Store<MainStoreState>,
    private dashboardService: DashboardService,
    private configService: ConfigService,
    public crudService: EsService
  ) {
    super(container, elRef.nativeElement, renderer, viewContainerRef, store);
  }

  ngOnInit(): void {
    this.gridWrapper = new GridWrapper<EvenementSpontane>(
      'EvenementSpontane',
      this.store.select(selectAllEvenementSpontanes),
      {
        logic: 'or',
        filters: [
          {
            field: 'idSegment',
            operator: 'contains',
          },
          {
            field: 'descriptionType',
            operator: 'contains',
          },
          {
            field: 'pgm.descriptionMode',
            operator: 'contains',
          },
          {
            field: 'descriptionPreconisation',
            operator: 'contains',
          },
          {
            field: 'pgm.descriptionEtatDetaille',
            operator: 'contains',
          },
        ],
      },
      this.kendoGrid
    );

    this.store.dispatch(loadEvenementSpontanesAction());
    this.crudService.refreshHubConnection();

    this.channel.addEventListener('message', (evt) => {
      if (evt.data.type === 'select') {
        const alarme: Alarme = evt.data.data;
        console.debug(`${alarme.description} selected`);
      }
    });
  }

  ngOnDestroy(): void {
    this.channel.close();
    this.gridWrapper.destroy();
  }

  zoomTo(event: MouseEvent, sp: IEvenementSpontane): void {
    event.stopPropagation();

    if (!this.configService.Config.layers) {
      return;
    }

    const data: IZoomEvent<IEvenementSpontane> = {
      type: 'zoom',
      title: this.configService.Config.layers.es.title,
      searchField: this.configService.Config.layers.es.searchField,
      searchText: sp.id.toString(),
      layerUrl: this.configService.Config.layers.es.url,
      subLayerIds: this.configService.Config.layers.es.layerIds,
    };

    if (this.dashboardService.isWidgetOpen('MapVecComponent')) {
      this.channel.postMessage(data);
      this.dashboardService.focusWidget('MapVecComponent');
    } else {
      this.dashboardService.openWidget('MapVecComponent', data);
    }
  }

  toogleAvancement(event: MouseEvent, dataItem: IEvenementSpontane): void {
    if (this.dashboardService.isWidgetOpen('AvancementListComponent')) {
      this.channelAvancementList.postMessage(dataItem);
      this.dashboardService.focusWidget('AvancementListComponent');
    } else {
      this.dashboardService.openWidget('AvancementListComponent', dataItem);
    }
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.gridWrapper.gridState.filter = filter;
    this.gridWrapper.gridData.data = filterBy(this.gridWrapper.gridData.data, filter);
  }

  public distinctPrimitive(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.gridData.data, fieldName).map(
      // @ts-ignore
      (item) => item[fieldName]
    );
  }

  public distinctPrimitiveEtat(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.gridData.data, fieldName).map(
      // @ts-ignore
      (item) => item.pgm?.descriptionEtatDetaille
    );
  }

  public distinctPrimitiveMode(fieldName: string): unknown[] {
    return distinct(this.gridWrapper.gridData.data, fieldName).map(
      // @ts-ignore
      (item) => item.pgm?.descriptionMode
    );
  }
}
